<template>
  <div>
    <div class="warning-alert" v-if="type == 'warning'">
      <vs-icon class="warning-icon" style="font-size: 25px;" icon="speakol-warning" icon-pack="speakol"></vs-icon>
      <span class="warning-title pl-1 font-normal text-black">{{ $t('Warning') }}</span>
      <p class="warning-desc pl-8 font-normal pt-1 pb-1">
        {{ message }}
        <br />
      </p>
        <a class="ml-8 warning-action" href="#" @click.prevent="action">
          {{ $t('Edit and Confirm') }}
        </a>
    </div>

    <div class="info-alert" v-if="type == 'info'">
      <vs-icon class="info-icon" style="font-size: 25px;" icon="speakol-info" icon-pack="speakol"></vs-icon>
      <span class="info-title pl-1 font-normal text-black">{{ $t('Info') }}</span>
      <p class="info-desc pl-8 font-normal pt-1 pb-1">
        <!-- You will pay 0.20 per mile except the custmized websites you confirm on. If i want to get back to custmization. -->
        {{ message }}
        <a class="ml-1 info-action" href="#" @click.prevent="action">{{ $t('Click Here') }}</a>
      </p>
    </div>

    <div class="error-alert" v-if="type == 'error'">
      <vs-icon class="error-icon" style="font-size: 25px;" icon="speakol-error" icon-pack="speakol"></vs-icon>
      <span class="error-title pl-1 font-normal text-black">{{ $t('Error') }}</span>
      <p class="error-desc pl-8 font-normal pt-1 pb-1">
        <!-- You have some websites with high CPM so you have to choose, edit or confirm on this list before continue. -->
        {{ message }}
      </p>
        <a class="ml-8 error-action" href="#" @click.prevent="action">{{ $t('Edit and Confirm') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator (value) {
        return ['error', 'warning', 'info'].includes(value)
      }
    },
    action: {
      type: Function,
      required: true
    }
  }
}
</script>

<style lang="scss">
  @media (max-width: 576px) {
    .error-desc,
    .info-desc,
    .warning-desc {
      margin-bottom: 10px;
    }
  }

  .warning-action,
  .info-action,
  .error-action {
    font-size: 12px;
  }
</style>